//
// Initialize plugins and behaviors on document ready
//
$(function () {

    masonry.init()

    navbar.init()

    switchButton.init()

    infobulle.init()

    buttonCard.init()

    swiper.init()

    modalAcess.init()

    modalFullScreen.init()

    voletContent.init()

    bntReturn.init()

    sidebarNav.init()

    carouselSlider.init()

    tabList.init()

    flipCard.init()

    stickyHeader.init()

    sideNav.init()

    dropdownMenu.init()

    dropdownFloatingMenu.init()

    inputBtn.init()

    scrollSummary.init()

    uploadButton.init()

    dsBadge.init()

    dsNavLinkGroup.init()

    dsHeader.init()

    // modalButton.init()

    // telInput.init()

    //  tooltip.init()

    //  spinButton.init()

})


var masonry = {
    init: function () {
        $('.grid').masonry({
            transitionDuration: 0,
            itemSelector: ".grid-item",
            fitWidth: true,
            gutter: 20
        });
    }
}

//
// Add extra behavior to the navbar
//

var navbar = {
    init: function () {
        if (!window.utils.isMobile()) {
            this.initDropdownHover()
        }
    },
    // show/hide dropdown on hover
    initDropdownHover: function () {
        var $dropdowns = $('.navbar .dropdown')
        $dropdowns.each(function (index, item) {
            var $item = $(this)

            $item.hover(function () {
                $item.addClass("show")
                $item.find("> .dropdown-toggle").attr("aria-expanded", true)
                $item.find("> .dropdown-menu").addClass("show")
            }, function () {
                $item.removeClass('show')
                $item.find("> .dropdown-toggle").attr("aria-expanded", false)
                $item.find("> .dropdown-menu").removeClass("show")
            })
        })
    },

}


//
// Extra Helpers
//

window.utils = {
    isMobile: function () {
        return window.innerWidth <= 992;
    }
}

//
// cartes de choix
//

// à supprimer

var buttonCard = {
    init: function () {
        $('.a-btnCard').click(function () {
            $(this).toggleClass('');
        })
    }
}

//
// Switch button
//

var switchButton = {

    init: function () {
        $('.a-toggle').click(function (evt) {

            let el = evt.target;

            if (el.getAttribute("aria-checked") == "true") {
                el.setAttribute("aria-checked", "false");
            } else {
                el.setAttribute("aria-checked", "true");
            }

        })
    }
}




//
// disparition de l'infobulle au clic sur le bouton de fermeture
//

// à supprimer

var infobulle = {
    init: function () {
        $('.openInfobulle').on("mouseleave", function () {
            $(this).next().hide(200);
        });
        $('.openInfobulle').on("mouseenter", function () {
            $(this).next().show(200);
        });
        $('.openInfobulle').focus(function () {
            $(this).next().show(200);
        });
        $('.closeInfobulle').focus(function () {
            $('.m-infobulle').hide(200);
        });
    }
}


//
// swiper
//

// à supprimer ? -Vérifier

var swiper = {
    init: function () {
        $("[data-toggle='swiper']").each(function (index, item) {
            new Swiper(item, $(item).data('options'))
        })
    }
}


//
// switch focus  between close & button - forbidden focus to the container of modal
//
var modalAcess = {
    init: function () {
        $(function () {
            //            $('#m-findIdentifiantHelpModalId, #o-dragAndDropModalId').on('shown.bs.modal', function () {
            //                $('.getFocus').trigger('focus');
            //            });
            //            $('#m-findIdentifiantHelpModalId, #o-dragAndDropModalId').focus(function () {
            //                $('.getFocus').trigger('focus');
            //            });
            $('.modal').on('shown.bs.modal', function () {
                $(this).find('.getFocus').trigger('focus');
            });
            $('.modal').on('focus', function () {
                $(this).find('.getFocus').trigger('focus');
            });
        })
    }
}



//
// Modification de la modale pour le fullscreen
//
var modalFullScreen = {
    init: function () {

        var button = $('.-modalFullScreen');

        button.on('click', function () {

            $('.o-fullscreenSignatureModal').on('shown.bs.modal', function () {
                $('.modal-backdrop').attr('style', 'background-color: #FFFFFF !important; top: 84px; opacity: 1 !important;');
                window.scrollTo(0, 0);
            });

        });

    }
}



//
// Volet button
//

// pas présent sur l'espace bénéficaire ni assurance. à vérifier sur indemnisation

var voletContent = {
    init: function () {

        var countTime = 0;
        var header = $('.o-voletContent');
        var buttonInfo = $('.a-btn.-languette');
        if (!header.hasClass("visible")) {
            var TimeInterval = setInterval(function () {
                ++countTime;
                header.addClass('visible');
                buttonInfo.attr('aria-expanded', 'true');
                $('.o-voletContent__boxText').show();
                $('.o-voletContent__closeButton').show();
                if (countTime >= 2) {
                    clearInterval(TimeInterval);
                    header.removeClass('visible');
                    buttonInfo.attr('aria-expanded', 'false');
                    $('.o-voletContent__boxText').hide();
                    $('.o-voletContent__closeButton').hide();
                }
            }, 4000);
        }
        buttonInfo.on('click', function () {
            header.toggleClass('visible');
            if (header.hasClass('visible')) {
                buttonInfo.attr("aria-expanded", "true");
                $('.o-voletContent__boxText').show();
                $('.o-voletContent__closeButton').show();
            } else {
                buttonInfo.attr("aria-expanded", "false");
                setTimeout(function () {
                    $('.o-voletContent__boxText').hide();
                    $('.o-voletContent__closeButton').hide();
                }, 500);
            }

        })
        $('.a-btn.getCloseHelp').on('click', function () {
            $('.o-voletContent').removeClass('visible');
            $('.a-btn.-languette').attr("aria-expanded", "false");
            setTimeout(function () {
                $('.o-voletContent__boxText').hide();
                $('.o-voletContent__closeButton').hide();
            }, 500);

        })
    }
}


// vérifier sur les projets qui utilise common feature avec Abdelkrim - pas d'impact sur benef.

var bntReturn = {
    init: function () {
        $(function () {
            $("[id*='return']").on('click', function (event) {
                event.preventDefault();
                window.location.href = "${backURL}";
            });
        })
    }
}



var sidebarNav = {
    init: function () {
        $(document).on('click', '.sidebarClose', function () {
            $('.modal-backdrop').remove();
            $('#sidebarNav').modal('hide');
        });
    }
}

// Pas présent sur beneft, vérifier sur les autres projets. 

var carouselSlider = {
    init: function () {
        $('.carousel-indicators li').on('click', function () {
            $(this).attr('aria-selected', 'true');
            $(this).attr('tabindex', "0");
            $('.carousel-indicators li').not(this).attr('aria-selected', 'false');
            $('.carousel-indicators li').not(this).attr('tabindex', "-1");
        })

        $('.carousel-indicators li').keydown(function (event) {
            var nextElement = null;
            switch (event.key) {
                case "ArrowLeft":
                    var leftElement = null
                    if (this.previousElementSibling === null) {
                        leftElement = this.parentElement.lastElementChild;
                    } else {
                        leftElement = this.previousElementSibling;
                    }
                    nextElement = leftElement;
                    break;
                case "ArrowRight":
                    var rightElement = null;
                    if (this.nextElementSibling === null) {
                        rightElement = this.parentElement.firstElementChild;
                    } else {
                        rightElement = this.nextElementSibling;
                    }
                    nextElement = rightElement;
                    break;
                default: return;
            }
            nextElement.focus();
            nextElement.classList.add('active');
            nextElement.setAttribute('tabindex', 0);
            nextElement.setAttribute('aria-selected', 'true');

            this.setAttribute('aria-selected', 'false');
            this.setAttribute('tabindex', -1);
            this.classList.remove('active');
        })

    }
}

var telInput = {
    init: function () {
        var errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
        var input = document.querySelector("#phone");
        var iti = intlTelInput(input, {
            initialCountry: "fr",
            preferredCountries: ["fr", "us", "ru", "de", "es"],
            separateDialCode: false,
            utilsScript:
                "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
        });
        input.addEventListener('blur', function () {
            if (input.value.trim()) {
                if (iti.isValidNumber()) {
                    console.log("hide");
                } else {
                    input.classList.add("error");
                    var errorCode = iti.getValidationError();
                    var errorMsg = errorMap[errorCode];
                    console.log(errorMsg);
                }
            }
        });

    }
}

// Gestion des flipCards
var flipCard = {
    init: function () {
        $(".m-flipCard__inner__face.-back").hide();
        $('.flipCardFlip').on('click', function () {
            $(this).parents(".m-flipCard").addClass('isFlipped');
            $(this).parents(".m-flipCard .m-flipCard__inner__face.-front").delay(1000).fadeOut();
            $(this).parents(".m-flipCard__inner__face.-front").siblings().delay(100).fadeIn();
        })
        $('.flipCardFlipBack').on('click', function () {
            $(this).parents(".m-flipCard").removeClass('isFlipped');
            $(this).parents(".m-flipCard .m-flipCard__inner__face.-back").delay(1000).fadeOut();
            $(this).parents(".m-flipCard__inner__face.-back").siblings().delay(100).fadeIn();
        })
    }
}

// Gestion du masquage du menu
var stickyHeader = {
    init: function () {
        var lastScrollTop = 0;
        var delta = 5;
        var navbarHeight = $('.o-header').outerHeight();

        $(window).on('scroll', function () {
            var st = $(this).scrollTop();

            if (Math.abs(lastScrollTop - st) <= delta)
                return;

            if (st > lastScrollTop && st > navbarHeight) {
                $('.o-header').addClass('-navUp').css('top', '-' + navbarHeight + 'px');
            } else {
                if (st + $(window).height() < $(document).height()) {
                    $('.o-header').removeClass('-navUp').css('top', '0');
                }
            }

            lastScrollTop = st;
            if ($('.m-sidenav').length) {
                adjustSidebarHeight();
            }
        });

        function adjustSidebarHeight() {
            var headerHeight = $('.o-header').outerHeight();
            var windowHeight = $(window).height();
            var scrollTop = $(window).scrollTop();

            // Position du haut du footer par rapport au haut de la page
            var footerTop = $('.o-footer').offset().top;

            // Si le haut du footer est visible dans la fenêtre
            var isFooterVisible = (footerTop <= scrollTop + windowHeight);

            // Hauteur disponible pour la sidebar
            var availableHeight;

            if (isFooterVisible) {
                // Si le footer est visible, la sidebar s'arrête au début du footer
                availableHeight = footerTop - headerHeight - scrollTop;
            } else {
                // Sinon, la sidebar prend toute la hauteur de la fenêtre moins le header
                availableHeight = windowHeight - headerHeight;
            }

            // Présence ou non de la navBar
            if ($('.o-header').hasClass('-navUp')) {
                // Si la navBar est cachée, on ajuste la hauteur et la position
                availableHeight = availableHeight + headerHeight;

                $('.m-sidenav').css({
                    'top': 0 + 'px',
                    'height': Math.max(availableHeight, 0) + 'px',
                    'border-top': 'none'
                });

            } else {
                // Si la navBar est visible, on ajuste la hauteur et la position
                availableHeight = availableHeight;

                $('.m-sidenav').css({
                    'top': headerHeight + 'px',
                    'height': Math.max(availableHeight, 0) + 'px',
                    'border-top': '1px solid #E6E6E6'
                });
            }
        }
    }
};

var sideNav = {
    init: function () {
        $(document).ready(function () {
            if ($('.m-sidenav').length) {
                this.setupSidebar();
                this.setupEventListeners();
            }
        }.bind(this));
    },

    setupSidebar: function () {
        this.adjustSidebarHeight();
        this.adjustSidebarWidth();
    },

    setupEventListeners: function () {
        var self = this;
        $(window).on('resize scroll', function () {
            self.adjustSidebarHeight();
        });

        $('.m-sidenav__drawer').on('click', function () {
            self.toggleSidebar();
        });
    },

    adjustSidebarHeight: function () {
        var headerHeight = $('.o-header').outerHeight();
        var windowHeight = $(window).height();
        var scrollTop = $(window).scrollTop();
        var footerTop = $('.o-footer').offset().top;
        var isFooterVisible = (footerTop <= scrollTop + windowHeight);
        var availableHeight = isFooterVisible ? footerTop - headerHeight - scrollTop : windowHeight - headerHeight;

        if ($('.o-header').hasClass('-navUp')) {
            availableHeight += headerHeight;
            $('.m-sidenav').css({
                'top': '0px',
                'height': Math.max(availableHeight, 0) + 'px',
                'border-top': 'none'
            });
        } else {
            $('.m-sidenav').css({
                'top': headerHeight + 'px',
                'height': Math.max(availableHeight, 0) + 'px',
                'border-top': '1px solid #E6E6E6'
            });
        }
    },

    adjustSidebarWidth: function () {
        if ($('.m-sidenav').hasClass('-open')) {
            this.closeSidebar();
        } else {
            this.openSidebar();
        }
    },

    toggleSidebar: function () {
        if ($('.m-sidenav').hasClass('-open')) {
            this.closeSidebar();
        } else {
            this.openSidebar();
        }
    },

    openSidebar: function () {
        $('.m-sidenav').removeClass('-closed').addClass('-open');
        $('.main-content.sidenav .container').animate({ 'padding-left': '274px'}, 200);
        $('.m-sidenav__drawer span.icon').removeClass('icon-sidebar-open').addClass('icon-sidebar-close');
        $('.m-sidenav__drawer .a-btn').attr("aria-expanded", true).attr('title', 'Fermer le menu de navigation');
        $('.m-sidenav__drawer span.sr-only').text('Fermer le menu de navigation');
    },

    closeSidebar: function () {
        $('.m-sidenav').removeClass('-open').addClass('-closed');
        $('.main-content.sidenav .container').animate({ 'padding-left': '74px'}, 200);
        $('.m-sidenav__drawer span.icon').removeClass('icon-sidebar-close').addClass('icon-sidebar-open');
        $('.m-sidenav__drawer .a-btn').attr("aria-expanded", false).attr('title', 'Ouvrir le menu de navigation');
        $('.m-sidenav__drawer span.sr-only').text('Ouvrir le menu de navigation');
    }
};

// Utilisé pour le sous-menu de l'esapce public.
// 
var dropdownMenu = {
    init: function () {
        $('.dropdown').on('show.bs.dropdown', function () {
            $('body').addClass("nav-overlay");
        })
        $('.dropdown').on('hide.bs.dropdown', function () {
            $('body').removeClass("nav-overlay");
        })
    }
}

var dropdownFloatingMenu = {
    init: function () {

        function debounce(fn, wait) {
            var t;
            return function () {
                var args = arguments;
                clearTimeout(t);
                t = setTimeout(function () { fn.apply(null, args); }, wait);
            };
        }

        // --- Alignement Bottom Left (déjà fonctionnel) ---
        function alignMenuBottomLeft($container) {
            var $menu = $container.find('.dropdown-menu');
            var $button = $container.find('.dropdown-toggle');

            if (!$menu.length || !$button.length) return;

            var menu = $menu[0];
            var btn = $button[0];

            var menuRect = menu.getBoundingClientRect();
            var btnRect = btn.getBoundingClientRect();
            var op = menu.offsetParent || document.documentElement;
            var opRect = op.getBoundingClientRect();

            var buttonTopRelToOP = btnRect.top - opRect.top;
            var buttonLeftRelToOP = btnRect.left - opRect.left;
            var buttonHeight = btnRect.height;
            var menuHeight = menuRect.height;

            var desiredTop = buttonTopRelToOP + buttonHeight - menuHeight;
            var fixedShift = menuRect.width + 4;
            var desiredLeft = buttonLeftRelToOP - fixedShift;

            menu.style.setProperty('top', desiredTop + 'px', 'important');
            menu.style.setProperty('left', desiredLeft + 'px', 'important');
            menu.style.removeProperty('right');
            menu.style.setProperty('transform', 'none', 'important');
            menu.style.setProperty('will-change', 'auto', '');
        }

        // --- Alignement Bottom Right ---
        function alignMenuBottomRight($container) {
            var $menu = $container.find('.dropdown-menu');
            var $button = $container.find('.dropdown-toggle');

            if (!$menu.length || !$button.length) return;

            var menu = $menu[0];
            var btn = $button[0];

            var menuRect = menu.getBoundingClientRect();
            var btnRect = btn.getBoundingClientRect();
            var op = menu.offsetParent || document.documentElement;
            var opRect = op.getBoundingClientRect();

            var buttonTopRelToOP = btnRect.top - opRect.top;
            var buttonHeight = btnRect.height;
            var menuHeight = menuRect.height;

            var desiredTop = buttonTopRelToOP + buttonHeight - menuHeight;

            menu.style.setProperty('top', desiredTop + 'px', 'important');
            menu.style.setProperty('right', 'auto', 'important');
            menu.style.removeProperty('left');
            menu.style.setProperty('transform', 'none', 'important');
            menu.style.setProperty('will-change', 'auto', '');
        }

        // --- Navigation clavier RGAA ---
        function setupKeyboardNavigation($container) {
            var $menu = $container.find('.dropdown-menu');
            var $items = $menu.find('[role="menuitem"]');
            var $button = $container.find('.dropdown-toggle');

            if (!$menu.length || !$items.length) return;

            $container.on('keydown', function (e) {
                var $focused = $(document.activeElement);
                var index = $items.index($focused);

                switch (e.key) {
                    case 'ArrowDown':
                        e.preventDefault();
                        if (index < $items.length - 1) {
                            $items.eq(index + 1).focus();
                        } else {
                            $items.eq(0).focus(); // boucle
                        }
                        break;
                    case 'ArrowUp':
                        e.preventDefault();
                        if (index > 0) {
                            $items.eq(index - 1).focus();
                        } else {
                            $items.eq($items.length - 1).focus(); // boucle
                        }
                        break;
                    case 'Escape':
                        e.preventDefault();
                        $button.dropdown('toggle');
                        $button.focus();
                        break;
                    case 'Tab':
                        // Fermer le menu si on sort du menu
                        if (!$menu.has(document.activeElement).length) {
                            $button.dropdown('hide');
                        }
                        break;
                }
            });

            // focus automatique sur le premier item à l'ouverture
            $container.on('shown.bs.dropdown', function () {
                setTimeout(function () {
                    $items.eq(0).focus();
                }, 50);
            });
        }

        // --- Events d’ouverture : alignement + clavier ---
        $('.o-floating-menu').on('shown.bs.dropdown', function () {
            var $container = $(this);

            // alignement dynamique selon la classe
            if ($container.hasClass('dropBottomLeft')) {
                requestAnimationFrame(function () { alignMenuBottomLeft($container); });
                setTimeout(function () { alignMenuBottomLeft($container); }, 30);
            } else if ($container.hasClass('dropBottomRight')) {
                requestAnimationFrame(function () { alignMenuBottomRight($container); });
                setTimeout(function () { alignMenuBottomRight($container); }, 30);
            }

            // active la navigation clavier (tous les cas)
            setupKeyboardNavigation($container);

            // écoute du resize/scroll
            var onResizeScroll = debounce(function () {
                var $menu = $container.find('.dropdown-menu');
                if ($menu.hasClass('show')) {
                    if ($container.hasClass('dropBottomLeft')) alignMenuBottomLeft($container);
                    if ($container.hasClass('dropBottomRight')) alignMenuBottomRight($container);
                }
            }, 80);
            $container.data('dfm_handler', onResizeScroll);
            window.addEventListener('resize', onResizeScroll);
            window.addEventListener('scroll', onResizeScroll, true);
        });

        // --- Cleanup à la fermeture ---
        $('.o-floating-menu').on('hide.bs.dropdown', function () {
            var $container = $(this);
            var $menu = $container.find('.dropdown-menu');

            if ($menu.length) {
                $menu[0].style.removeProperty('top');
                $menu[0].style.removeProperty('left');
                $menu[0].style.removeProperty('right');
                $menu[0].style.removeProperty('transform');
                $menu[0].style.removeProperty('will-change');
            }

            var handler = $container.data('dfm_handler');
            if (handler) {
                window.removeEventListener('resize', handler);
                window.removeEventListener('scroll', handler, true);
                $container.removeData('dfm_handler');
            }
        });
    }
};

var scrollSummary = {
    init: function () {

        if ($('.m-navigationToSummary').length) {
            window.onscroll = function () {
                if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
                    $('.m-navigationToSummary').show(500);
                } else {
                    $('.m-navigationToSummary').hide(500);
                }
            }
        }
    }
}

var inputBtn = {
    init: function () {
        let textInput = $('.-inputButton .a-fieldText');
        let btnInput = $('.a-fieldText + .a-btn.-icon');

        //on cache le bouton par défaut
        btnInput.hide();

        // détection du texte dans le champ de saisie pou faire apparaitre le bouton
        textInput.on("input", function () {
            if ($(this).val() != "") {
                $(this).next().show();
            } else {
                $(this).next().hide();
            }
        });

        btnInput.on("click", function () {
            $(this).prev().val("");
            $(this).hide();
        })
    }
}

var modalButton = {
    init: function () {
        $('.m-modal__content__footer > .a-btn').each(function () {
            let buttonModal = $(this);
            let buttonModaltext = buttonModal.text();
            let textButtonlength = buttonModaltext.length;

            let siblingHasFullWidth = buttonModal.siblings('.m-modal__content__footer > .a-btn').filter(function () {
                return $(this).text().length > 12;
            }).length > 0;

            if (textButtonlength < 12 && !siblingHasFullWidth) {
                buttonModal.css('width', 'fit-content');
            } else if (siblingHasFullWidth) {
                buttonModal.css('width', '100%');
            }
        })

    }
}


var tabList = {
    init: function () {
        const tabs = $('.m-tab');
        const panels = $('.o-tabs__content__pane');

        function activateTab($tab) {
            // Met à jour les onglets
            tabs.attr('aria-selected', 'false').attr('tabindex', '-1');
            $tab.attr('aria-selected', 'true').attr('tabindex', '0').focus();

            // Met à jour les panneaux
            panels.attr('hidden', 'true');
            const panelId = $tab.attr('aria-controls');
            $('#' + panelId).removeAttr('hidden');
        }

        // Gestion des clics
        tabs.on('click', function () {
            activateTab($(this));
        });

        // Gestion du clavier
        tabs.on('keydown', function (e) {
            const $currentTab = $(this);
            const currentIndex = tabs.index(this);
            let newIndex;

            switch (e.key) {
                case 'ArrowRight':
                    newIndex = (currentIndex + 1) % tabs.length;
                    break;
                case 'ArrowLeft':
                    newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
                    break;
                case 'Home':
                    newIndex = 0;
                    break;
                case 'End':
                    newIndex = tabs.length - 1;
                    break;
                case 'Enter':
                case ' ':
                    activateTab($currentTab);
                    return false;
            }

            if (newIndex !== undefined) {
                tabs.eq(newIndex).focus();
            }
        });
    }
}

//
// Upload button
//

var uploadButton = {
    init: function () {
        if (typeof $.fn.uploadButton === "function") {
            $('.auto-init .-uploadButton .a-input__file').uploadButton({
                allowedExtensions: ['pdf', 'jpg', 'jpeg', 'png'],
                fileMaxSize: '5MB',
                totalFilesMaxSize: '5MB',
                messages: {
                    fr: {
                        buttonTitle: null,
                        buttonDescription: null,
                    }
                },
                onValidate: async function (file) {
                    const errors = [];

                    // Vérification PDF
                    const getPdfDocument = window.getPdfDocument;
                    if (file.name.toLowerCase().endsWith('.pdf') && getPdfDocument) {
                        try {
                            const pdf = await getPdfDocument(URL.createObjectURL(file)).promise;
                            if (pdf.numPages === 0) {
                                errors.push("PDF file appears to be empty");
                            }
                            if (pdf.numPages > 2) {
                                errors.push("PDF file exceeds maximum page count (2 pages)");
                            }
                        } catch (error) {
                            errors.push("PDF file is corrupted or invalid");
                        }
                    }

                    return errors; // Return array of errors
                },
                onDelete: function (file, controlledTarget, callback) {
                    if (controlledTarget) {
                        // Utiliser une modale Bootstrap pour la confirmation
                        $(controlledTarget).find('.file-to-delete').html(file.name);
                        $(controlledTarget).modal('show');

                        // Détacher les anciens gestionnaires d'événements
                        $(controlledTarget).off('click', '#confirmDeleteBtn');
                        $(controlledTarget).off('click', '#cancelDeleteBtn');

                        // Exemple de gestion de la confirmation
                        $(controlledTarget).on('click', '#confirmDeleteBtn', function () {
                            callback(true); // Confirmer la suppression
                            $(controlledTarget).modal('hide');
                        });

                        $(controlledTarget).on('click', '#cancelDeleteBtn', function () {
                            callback(false); // Annuler la suppression
                            $(controlledTarget).modal('hide');
                        });
                    }
                }
            });

            $('.auto-init-with-uploaded .-uploadButton .a-input__file').uploadButton({
                allowedExtensions: ['pdf', 'jpg', 'jpeg', 'png'],
                fileMaxSize: '1MB',
                totalFilesMaxSize: '5MB',
                maxFiles: 5,
                hideUploadButtonOnMaxFilesReached: true,
                uploadedFiles: [
                    { name: "Document_2.pdf", url: "https://cdn.cardif.fr/file/doc-2.pdf", uploadDate: "2025-11-14T08:30:49Z" },
                    { name: "Document_1 avec un nom très très très très très très long.pdf", url: "https://cdn.cardif.fr/file/doc-1.pdf", uploadDate: "2025-11-13T10:30:22Z" }
                ]
            });
        }
    }
}

//
// dsBadge
//

var dsBadge = {
    init: function () {
        if (typeof $.fn.dsBadge === "function") {
            $('[data-ds-badge-label], [data-ds-badge-message]').dsBadge();
        }
    }
}

//
// dsNavLinkGroup
//

var dsNavLinkGroup = {
    init: function () {
        if (typeof $.fn.dsNavLinkGroup === "function") {
            $('.m-nav-link-group').dsNavLinkGroup({
                dsCollapseBreakpoint: 'xl'
            });
        }
    }
}

//
// dsHeaderNav
//

var dsHeader = {
    init: function () {
        if (typeof $.fn.dsHeader === "function") {
            $('#bnp-cardif-header').dsHeader();
        }
    }
}


